import React,{useEffect, useState} from 'react';
import Recipe from './Recipe';
import './App.css';

const App = () =>{

  const APP_ID = '94e77a2e';
  const APP_KEY = '6ba35f748bf996b3445f189ce9a4075d';
  const exampleReq = `https://api.edamam.com/search?q=chicken&app_id=${APP_ID}&app_key=${APP_KEY}`;  

  const [recipes, setRecipes] = useState([]);
  const [search, setSearch] = useState('');
  const [querry, setQuerry] = useState('chicken');

  useEffect(() =>{
    getRecipes();
  },[querry]);

  const getRecipes = async () => {
    const response = await fetch(`https://api.edamam.com/search?q=${querry}&app_id=${APP_ID}&app_key=${APP_KEY}`);
    const data = await response.json();
    setRecipes(data.hits);
    console.log(data.hits);
  }

  const updateSearch = e => {
    setSearch(e.target.value);
  }

  const getSearch = e => {
    e.preventDefault();
    setQuerry(search);
    setSearch('');
  }

  return (
    <div className="App">
      <form className="search-form" onSubmit={getSearch} >
        <input className="search-bar" type="text" value={search} onChange={updateSearch} />
        <button className="search-button" type="submit">  Search </button> 
      </form>

      <div className="recipes">
      {recipes.map(recipe => (
        <Recipe 
        key={recipe.recipe.label}
        title={recipe.recipe.label} 
        calories={recipe.recipe.calories} 
        image={recipe.recipe.image}
        ingredients={recipe.recipe.ingredients} />
      ))}
      </div>
     
    </div>
  );
}

export default App;
